const API_URL = "https://api.jsabordeauxvolley.fr"

const ENVIRONMENT =  {
    API_URL
}

export default ENVIRONMENT;
